import { IFRAME_SEARCH_PARAM_KEYS } from '@/constants/iframe'
import { queryParametersSchema } from '@/schemas/room'
import { useParams, useSearchParams } from 'next/navigation'

export const useEnableViewMode = () => {
  const { roomId } = useParams()
  const searchParams = useSearchParams()

  const viewModeParam = searchParams?.get(IFRAME_SEARCH_PARAM_KEYS.VIEW)
  const parseResult = queryParametersSchema.safeParse({ view: viewModeParam })
  const enableViewMode = Boolean(roomId && parseResult.success && parseResult.data.view)

  return enableViewMode
}
